import styled from 'react-emotion';

export default styled.ul`
	font-size: 0.8125rem;
	line-height: 1.75;
	list-style: none;
	margin: 0;
	padding: 0;

	:not(:last-child) {
		margin-bottom: 2rem;
	}

	li {
		margin: 0;
		padding: 0;
	}

	a,
	button {
		color: #333;
		font-size: inherit;
		text-decoration: underline;

		&:hover {
			text-decoration: none;
		}
	}

	button {
		background: none;
		border: 0;
		cursor: pointer;
		padding: 0;
	}
`
